import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../api.service';
import { IccCaptureEligibilityFindingsImport } from 'app/core/models/icc/icc-capture-eligibility-findings-import.model';
import { IccImportFilters } from 'app/core/models/icc/icc-import-settings.model';
import { LimitOffsetPagingMeta } from 'app/core/models/paged-results/limit-offset-paging.model';
import { PagedResults } from 'app/core/models/paged-results/paged-results.model';

export class PagedIccCaptureEligibilityFindingsImports implements PagedResults {
  captureEligibilityFindingsImports: IccCaptureEligibilityFindingsImport[];
  meta: LimitOffsetPagingMeta;

  get records() {
    return this.captureEligibilityFindingsImports;
  }
}

@Injectable()
export class IccCaptureEligibilityFindingsImportsService extends ApiService {
  private http = inject(HttpClient);


  get(id): Observable<IccCaptureEligibilityFindingsImport> {
    return this.http.get<IccCaptureEligibilityFindingsImport>(
      `${environment.captureApi.url}/icc/capture_eligibility_findings_imports/${id}`
    );
  }

  getList(
    paging: { page: number; pageSize: number } = null,
    _filters: IccImportFilters = null
  ): Observable<PagedIccCaptureEligibilityFindingsImports> {
    const params = new URLSearchParams();

    if (paging) {
      params.append('page', paging.page.toString());
      params.append('per_page', paging.pageSize.toString());
    }

    return this.http.get<PagedIccCaptureEligibilityFindingsImports>(
      `${environment.captureApi.url}/icc/capture_eligibility_findings_imports?${params.toString()}`
    );
  }

  create(name: string, signedId: string): Observable<IccCaptureEligibilityFindingsImport> {
    return this.http.post<IccCaptureEligibilityFindingsImport>(
      `${environment.captureApi.url}/icc/capture_eligibility_findings_imports`,
      {
        captureEligibilityFindingsImport: { name, signedId },
      }
    );
  }

  update(id, name): Observable<IccCaptureEligibilityFindingsImport> {
    return this.http.put<IccCaptureEligibilityFindingsImport>(
      `${environment.captureApi.url}/icc/capture_eligibility_findings_imports/${id}`,
      {
        captureEligibilityFindingsImport: { name },
      }
    );
  }

  cancel(id): Observable<IccCaptureEligibilityFindingsImport> {
    return this.http.patch<IccCaptureEligibilityFindingsImport>(
      `${environment.captureApi.url}/icc/capture_eligibility_findings_imports/${id}/cancel`,
      {}
    );
  }
}
